import styled from "styled-components/macro";
import { Text, SelectControl, Card } from "../../common";
import { media } from "../../../utils";

export const FormContent = styled.div`
  width: 100%;
  ${media.md()} {
    width: 40%;
  }
`;

export const DateText = styled(Text)`
  margin-bottom: 0;
`;

export const ResultsCard = styled(Card)`
  padding: 24px 16px;
  box-shadow: 0px -2px 2px rgba(45, 41, 38, 0.05),
    0px 8px 12px rgba(45, 41, 38, 0.16);
  margin: 0 16px 16px;
  border-radius: 16px;
`;

export const ResultNumber = styled(Text)`
  color: ${({ theme }) => theme.color.brandPrimary.medium};
`;

export const LastResultsCard = styled(Card)`
  padding: 24px 16px;
  box-shadow: 0px -2px 2px rgba(45, 41, 38, 0.05),
    0px 8px 12px rgba(45, 41, 38, 0.16);
  margin: 0 16px 16px;
  border-radius: 16px;
  ${media.md()} {
    width: 33%;
  }
`;

export const NewRequestButton = styled.input`
  width: 100%;

  ${media.md()} {
    width: auto;
  }
`;

export const FormDataSorteios = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectDate = styled(SelectControl)`
  width: 45%;
`;

export const PremiosSorteados = styled.div`
  margin-left: 0 !important;
  ${({ combinacoes }) => (combinacoes.length <= 10 ? "max-width: 100%;" : "")}

  & > .Card__Body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
